import { inject, PLATFORM_ID, provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

export const CLASE_MODO_MOUSE = 'modo-mouse';

export function activarDeteccionModoTeclado(documento: Document, esNavegador: boolean): void {
  if (!esNavegador) return;

  const raiz = documento.documentElement;

  documento.addEventListener('mousedown', () => {
    raiz.classList.add(CLASE_MODO_MOUSE);
  });

  documento.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Tab') return;
    raiz.classList.remove(CLASE_MODO_MOUSE);
  });
}

export function proveedorDeteccionModoTeclado(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const platformId = inject(PLATFORM_ID);
    const documento = inject(DOCUMENT);

    activarDeteccionModoTeclado(documento, isPlatformBrowser(platformId));
  });
}
